<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Tambah Kelas Membership</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                placeholder="Nama Kelas Membership"
                outlined
                label="Nama Kelas"
                type="text"
                v-model="membershipClassName"
              ></v-text-field>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-card-text>
            <v-form>
              <v-switch
                v-model="hasBalanceMaxLimit"
                label="Limit saldo maksimum berlaku"
              ></v-switch>
              <v-expand-transition>
                <div v-show="hasBalanceMaxLimit">
                  <v-text-field
                    hint="Nilai saldo maksimum untuk kelas ini"
                    persistent-hint
                    outlined
                    placeholder="Masukkan nilai saldo maksimum"
                    type="number"
                    class="mb-4"
                    v-model="balanceMaxLimit"
                    :disabled="!hasBalanceMaxLimit"
                  ></v-text-field>
                </div>
              </v-expand-transition>

              <v-switch v-model="hasDeposit" label="Deposit berlaku"></v-switch>
              <v-expand-transition>
                <div v-show="hasDeposit">
                  <v-text-field
                    hint="Deposit yang ditarik dari penambahan saldo"
                    persistent-hint
                    outlined
                    type="number"
                    placeholder="Masukkan nilai deposit"
                    :disabled="!hasDeposit"
                    v-model="deposit"
                  ></v-text-field>
                </div>
              </v-expand-transition>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar flat>
            <v-toolbar-title>Masa Aktif</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap justify-start>
              <v-flex xs12 class="mb-4">
                <v-layout wrap justify-start>
                  <v-flex xs3>
                    <v-text-field
                      hint="Lama masa aktif saldo"
                      persistent-hint
                      outlined
                      label="Masa Aktif Saldo"
                      type="number"
                      v-model="balanceActivePeriodValue"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="balanceActivePeriodUnit"
                      :items="activePeriodUnits"
                      menu-props="auto"
                      outlined
                      placeholder="Satuan Masa Aktif Saldo"
                      item-value="value"
                      item-text="label"
                      single-line
                      solo
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap justify-start>
                  <v-flex xs3>
                    <v-text-field
                      hint="Lama waktu aktif bonus"
                      persistent-hint
                      outlined
                      label="Masa Aktif Bonus"
                      type="number"
                      v-model="bonusActivePeriodValue"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="bonusActivePeriodUnit"
                      :items="activePeriodUnits"
                      menu-props="auto"
                      outlined
                      placeholder="Satuan Masa Aktif Bonus"
                      item-value="value"
                      item-text="label"
                      single-line
                      solo
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" dark :to="mainPath"
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="addData"
                    >Tambah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      mainPath: process.env.VUE_APP_MEMBERSHIPCLASS_PATH,
      activePeriodUnitPath: process.env.VUE_APP_ACTIVEPERIODUNIT_PATH,
      membershipClassName: null,
      hasBalanceMaxLimit: false,
      balanceMaxLimit: null,
      hasDeposit: false,
      deposit: null,
      balanceActivePeriodValue: null,
      balanceActivePeriodUnit: null,
      bonusActivePeriodValue: null,
      bonusActivePeriodUnit: null,
      activePeriodUnits: []
    };
  },
  methods: {
    addData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.mainPath, {
          membershipClassName: self.membershipClassName,
          hasBalanceMaxLimit: self.hasBalanceMaxLimit,
          balanceMaxLimit: self.balanceMaxLimit,
          hasDeposit: self.hasDeposit,
          deposit: self.deposit,
          balanceActivePeriodValue: self.balanceActivePeriodValue,
          balanceActivePeriodUnit: self.balanceActivePeriodUnit,
          bonusActivePeriodValue: self.bonusActivePeriodValue,
          bonusActivePeriodUnit: self.bonusActivePeriodUnit
        })
        .then(function() {
          self.loadingMessage =
            "Sukses menambahkan kelas membership <b>" +
            self.membershipClassName +
            "</b>";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    fetchActivationUnit() {
      let self = this;
      this.axios
        .get(self.activePeriodUnitPath)
        .then(function(response) {
          self.activePeriodUnits = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    }
  },
  mounted: function() {
    this.fetchActivationUnit();
  },
  computed: {
    successScrollOptions() {
      return {
        duration: 1000,
        offset: 0,
        easing: "easeInOutCubic"
      };
    }
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
